<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" v-if="$can('tenantrole-edit')" />
        <action-button type="delete" @click="del(tenantrole.id)" v-if="$can('tenantrole-delete')" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tenantrole.name"
                  v-model="tenantrole.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('tenantroles.name')"
                  :error-messages="errors.collect('tenantrole.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tenantrole.slug"
                  v-model="tenantrole.slug"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('tenantroles.slug')"
                  :error-messages="errors.collect('tenantrole.slug')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <div v-if="tenantrole.id">
          <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
            <page-header-title :title="$t('roles.permission_btn')"></page-header-title>
          </v-app-bar>

          <v-expansion-panels class="mb-3 elevation-0" :value="Number(!expand)" v-for="item in all_permissions" :key="item.id">
            <v-expansion-panel>
              <v-expansion-panel-header class="transparent pl-2">
                <template v-slot:actions>
                  <v-icon class="expandable-icon mr-3">$expand</v-icon>
                </template>
                <span class="expandable-header">{{ item.module }}</span>
                <div class="expandable-action text-right">
                  (<v-btn text @click.native.stop @click="autoselect('check', item.module)">{{ $t("roles.check_all") }}</v-btn>
                  |
                  <v-btn text @click.native.stop @click="autoselect('uncheck', item.module)">{{ $t("roles.uncheck_all") }}</v-btn
                  >)
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container grid-list-md class="pa-0 ma-0">
                  <v-layout row wrap>
                    <v-flex v-for="data in item.permissions" :key="data.id" class="perm-row" xs12 md6>
                      <input
                        v-model="checked"
                        type="checkbox"
                        name="chk_permission"
                        :value="data.id"
                        :checked="checked.includes(data.name)"
                      />
                      {{ data.name }}
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "TenantRolesForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      predata: {},
      tenantrole: {},

      permissions: [],
      all_permissions: [],
      checked: [],

      expand: true,

      dictionary: {
        attributes: {
          "tenantrole.name": this.$t("tenantroles.name"),
          "tenantrole.slug": this.$t("tenantroles.slug")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.tenantrole, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  watch: {
    tenantrole: {
      handler(val) {
        if (!this.tenantrole.id) {
          let name = this.tenantrole.name ? this.tenantrole.name : ""
          this.tenantrole.slug = this.$slug(name)
        }
      },
      deep: true
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.tenantrole))

      this.setPageTitle()
      this.getPermissions()
    } else {
      this.title = this.$t("tenantroles.update_title")

      axios
        .get(this.API_URL + "tenantrole/" + this.id)
        .then((res) => {
          this.tenantrole = res.data.data

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.tenantrole))

          this.setPageTitle()
          this.getPermissions()
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    setPageTitle() {
      if (_.has(this.tenantrole, "id")) {
        this.page_title = this.$t("tenantroles.edit_tenantrole", {
          name: this.tenantrole.name
        })
      } else {
        this.page_title = this.$t("tenantroles.new_tenantrole")
      }
    },
    getPermissions() {
      let vm = this

      vm.permissions = vm.tenantrole.permissions

      axios
        .get(vm.API_URL + "tenantpermissions?show_all=true")
        .then((res) => {
          let _permissions = res.data.data
          let _all_permissions = []
          let _modules = []

          _permissions.forEach(function(item) {
            if (_modules.indexOf(item.module) === -1) {
              _modules.push(item.module)
            }
          })

          _modules.sort()

          // save all the permissions to "all_permissions" variable and group it by module
          for (let _module of _modules) {
            _all_permissions.push({
              module: _module,
              permissions: _permissions.filter((_permission) => _permission.module === _module)
            })
          }

          vm.all_permissions = _all_permissions

          // set checked permission
          if (vm.permissions.length > 0) {
            vm.permissions.forEach(function(value) {
              vm.checked.push(value.tenant_permission_id)
            })
          }
        })
        .catch((err) => console.log(err))
    },
    autoselect(type, mod = null) {
      let permissions = this.all_permissions.filter((i) => i.module == mod)[0].permissions.map((i) => i.id)

      if (type == "check") {
        this.checked.push(...permissions)
      } else {
        this.checked = this.checked.filter((item) => !permissions.includes(item))
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.tenantrole.id) {
              // Create
              axios
                .post(this.API_URL + "tenantrole", {
                  name: this.tenantrole.name,
                  slug: this.tenantrole.slug,
                  permissions: this.checked.join(","),
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.tenantrole = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.tenantrole))

                      vm.setPageTitle()
                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/tenantroles/edit/${vm.tenantrole.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "tenantrole", {
                  id: this.tenantrole.id,
                  name: this.tenantrole.name,
                  slug: this.tenantrole.slug,
                  permissions: this.checked.join(",")
                })
                .then((res) => {
                  vm.tenantrole = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.tenantrole))

                  vm.setPageTitle()
                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "tenantrole/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/tenantroles")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
